<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">{{ modalTitle }}</p>
      <button
        v-if="hasCloseButton"
        @click="close"
        class="delete"
        aria-label="close"
      ></button>
    </header>
    <section class="modal-card-body has-text-centered">
      <img
        v-if="slides[slide].image"
        :src="require(`@/assets/whats-new/${slides[slide].image}`)"
        :alt="slides[slide].updateTitle"
      />
      <h4 class="title is-5">{{ slides[slide].updateTitle }}</h4>
      <p class="subtitle is-6">{{ slides[slide].description }}</p>
      <div v-if="slides.length > 1" class="dots">
        <span
          v-for="(s, i) in slides"
          :key="i"
          :class="['dot', { active: i === slide }]"
        ></span>
      </div>
    </section>
    <footer class="modal-card-foot">
      <div class="columns" style="width: calc(100% + 1.5rem)">
        <div v-if="slides.length > 1" class="column">
          <button
            class="button is-fullwidth"
            @click="back"
            :disabled="!hasPreviousSlide()"
          >
            Back
          </button>
        </div>
        <div class="column">
          <button
            class="button is-info is-fullwidth"
            @click="hasNextSlide() ? next() : close()"
          >
            {{ hasNextSlide() ? 'Next' : 'Close' }}
          </button>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'WhatsNew',
  computed: {
    ...mapState({
      updates: state => state.modal.config.updates,
      hasCloseButton: state => state.modal.config.hasCloseButton ?? true,
      beforeClose: state => state.modal.config.beforeClose
    }),
    slides() {
      return this.updates.reduce((arr, update) => {
        return arr.concat(
          update.slides.map(slide => ({
            ...slide,
            updateTitle: update.title,
            updateType: update.type
          }))
        )
      }, [])
    },
    modalTitle() {
      const slide = this.slides[this.slide]
      return slide.updateType === 'coming-soon' ? 'Coming Soon!' : "What's New?"
    }
  },
  data() {
    return {
      slide: 0
    }
  },
  methods: {
    hasPreviousSlide() {
      return this.slide > 0
    },
    hasNextSlide() {
      return this.slide < this.slides.length - 1
    },
    back() {
      if (this.hasPreviousSlide()) {
        this.slide--
      }
    },
    next() {
      if (this.hasNextSlide()) {
        this.slide++
      }
    },
    close() {
      if (this.beforeClose) {
        this.beforeClose()
      }
      this.$modal.close()
    }
  }
}
</script>

<style lang="sass" scoped>
img
  width: 100%
  aspect-ratio: 16 / 9
  object-fit: cover
  display: block
  border-radius: 0.5rem
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.18)
  margin-bottom: 2rem
.dots
  margin-bottom: 1rem
  display: flex
  justify-content: center
  align-items: center
  gap: 0.5rem
.dot
  width: 0.5rem
  height: 0.5rem
  border-radius: 50%
  opacity: 0.5
  background: $border-background
  transition: background 0.2s, transform 0.2s, opacity 0.2s
.dot.active
  opacity: 1
  background: $secondary-background
  transform: scale(1.5)
</style>
